<template>
    <div class="edit-text">
        <template v-if="! isEditing">
            <p :class="textClass">
                {{ text }}
            </p>
            <a
                href="#"
                @click.prevent="toggleEditing"
            >
                <i class="fas fa-pencil" />
            </a>
        </template>
        <template v-else>
             <input
                v-model="editedText"
                v-on-clickaway="toggleEditing"
                type="text"
                @keyup.enter="isEditing = false"
            >
        </template>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [clickaway],

    props: {
        text: {
            type: String,
            required: true,
        },
        textClass: {
            type: Array,
            default: () => [],
        },
    },

    data: () => ({
        isEditing: false,
    }),

    computed: {
        editedText: {
            /**
             * Get value
             *
             * @returns {string} Value for input
             */
            get() {
                return this.text;
            },

            /**
             * Set value
             *
             * @param   {string}  value  Modified value
             *
             */
            set(value) {
                this.$emit('change', value);
            },
        },
    },

    methods: {
        /**
         * Handles click outside of the input
         */
        toggleEditing() {
            this.isEditing = ! this.isEditing;
        },
    },
};
</script>
